import { CypressRequestCollector } from '../../infrastructure';

export const cypressRequestCollector = new CypressRequestCollector();

window.transceptaCypressRequestCollector = cypressRequestCollector;
